// extracted by mini-css-extract-plugin
module.exports = {"pintxo-tab":"Tab_pintxo-tab__U5F0c","pintxo-tab__content":"Tab_pintxo-tab__content__MgiXn","pintxo-tab__indicator":"Tab_pintxo-tab__indicator__7u_Er"};